import React, { useState } from 'react';
import { XIcon, StarIcon, CheckCircleIcon, MapIcon, ArrowLeftIcon } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/Button';
import { FacilityLayoutModal } from '../components/FacilityLayoutModal';
import { useBookingCart } from '../contexts/BookingCartContext';
import { getCourtById } from '../data/courts';
import { getVenueById } from '../data/venues';
const courtData = {
  'court-1': {
    name: 'Court 1',
    courtNumber: 1,
    rating: 4.8,
    reviews: 6,
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp'],
    surface: 'Premium Padel',
    lighting: 'LED Floodlights',
    netQuality: 'Professional',
    amenities: 'Water, Seating',
    type: 'Indoor',
    priceUC: 15,
    price: 15,
    peakPriceUC: 20,
    peakPrice: 20
  },
  'court-2': {
    name: 'Court 2',
    courtNumber: 2,
    rating: 4.7,
    reviews: 5,
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp'],
    surface: 'Premium Padel',
    lighting: 'LED Floodlights',
    netQuality: 'Professional',
    amenities: 'Water, Seating',
    type: 'Indoor',
    priceUC: 15,
    price: 15,
    peakPriceUC: 20,
    peakPrice: 20
  },
  'court-3': {
    name: 'Court 3',
    courtNumber: 3,
    rating: 4.6,
    reviews: 4,
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp'],
    surface: 'Standard Padel',
    lighting: 'LED Floodlights',
    netQuality: 'Standard',
    amenities: 'Water, Shade',
    type: 'Indoor',
    priceUC: 15,
    price: 15,
    peakPriceUC: 20,
    peakPrice: 20
  },
  'court-4': {
    name: 'Court 4',
    courtNumber: 4,
    rating: 4.5,
    reviews: 3,
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp'],
    surface: 'Standard Padel',
    lighting: 'LED Floodlights',
    netQuality: 'Standard',
    amenities: 'Water, Shade',
    type: 'Indoor',
    priceUC: 15,
    price: 15,
    peakPriceUC: 20,
    peakPrice: 20
  },
  'court-5': {
    name: 'Court 5',
    courtNumber: 5,
    rating: 4.9,
    reviews: 8,
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp'],
    surface: 'Pickleball Court',
    lighting: 'LED Floodlights',
    netQuality: 'Professional',
    amenities: 'Water, Seating, Equipment',
    type: 'Indoor',
    priceUC: 15,
    price: 15,
    peakPriceUC: 20,
    peakPrice: 20
  },
  'court-6': {
    name: 'Court 6',
    courtNumber: 6,
    rating: 4.8,
    reviews: 7,
    images: ['https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp'],
    surface: 'Pickleball Court',
    lighting: 'LED Floodlights',
    netQuality: 'Professional',
    amenities: 'Water, Seating, Equipment',
    type: 'Indoor',
    priceUC: 15,
    price: 15,
    peakPriceUC: 20,
    peakPrice: 20
  }
};
// Court position mapping - precisely aligned to match actual court layout sizes
const courtPositions = {
  'lamunin-court-1': {
    x: 5,
    y: -2,
    width: 18,
    height: 43,
    labelX: 14,
    labelY: 20
  },
  'lamunin-court-2': {
    x: 29,
    y: -2,
    width: 18,
    height: 43,
    labelX: 38,
    labelY: 20
  },
  'lamunin-court-3': {
    x: 52,
    y: -2,
    width: 19,
    height: 43,
    labelX: 61.6,
    labelY: 20
  },
  'lamunin-court-4': {
    x: 72.5,
    y: -2,
    width: 18,
    height: 43,
    labelX: 82.75,
    labelY: 20
  },
  'lamunin-court-5': {
    x: 4.5,
    y: 50,
    width: 43,
    height: 21,
    labelX: 26,
    labelY: 63
  },
  'lamunin-court-6': {
    x: 52,
    y: 50,
    width: 43,
    height: 21,
    labelX: 73.5,
    labelY: 63
  }
};
export function CourtDetailScreen() {
  const navigate = useNavigate();
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isLayoutModalOpen, setIsLayoutModalOpen] = useState(false);
  const {
    addToCart
  } = useBookingCart();
  // Get court and venue data
  const court = getCourtById(id || '');
  const venue = court ? getVenueById(court.venueId) : null;
  if (!court || !venue) {
    return <div className="h-screen w-full flex items-center justify-center bg-white" data-id="element-463">
        <div className="text-center" data-id="element-464">
          <h2 className="text-2xl font-bold text-[#1f5070] mb-2" data-id="element-465">
            Court not found
          </h2>
          <button onClick={() => navigate('/home')} className="text-[#3dc7e3] font-bold" data-id="element-466">
            Return to venues
          </button>
        </div>
      </div>;
  }
  const handleAddToBooking = () => {
    addToCart({
      venueId: venue.id,
      venueName: venue.name,
      venueLocation: venue.location,
      courtId: court.id,
      courtName: court.name,
      date: 'Tomorrow',
      time: '3:00 PM - 4:00 PM',
      priceUC: court.priceUC,
      price: court.price,
      image: court.images[0]
    });
    navigate('/booking/cart');
  };
  return <div className="fixed inset-0 z-50 bg-white animate-slide-up" data-id="element-467">
      {/* Header */}
      <div className="bg-white px-4 py-4 flex items-center justify-between shadow-sm" data-id="element-468">
        <div className="flex items-center gap-3" data-id="element-469">
          <button onClick={() => navigate(`/venue/${venue.id}`)} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-470">
            <ArrowLeftIcon className="w-6 h-6 text-[#1f5070]" data-id="element-471" />
          </button>
          <div data-id="element-472">
            <p className="text-xs text-[#666666]" data-id="element-473">{venue.name}</p>
            <h1 className="text-base font-bold text-[#1f5070]" data-id="element-474">{court.name}</h1>
          </div>
        </div>
        <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-475">
          <XIcon className="w-6 h-6 text-[#1f5070]" data-id="element-476" />
        </button>
      </div>

      <div className="h-[calc(100vh-72px)] overflow-auto" data-id="element-477">
        {/* Image Carousel */}
        <div className="relative h-64 bg-gray-200" data-id="element-478">
          <img src={court.images[currentImageIndex]} alt={court.name} className="w-full h-full object-contain" data-id="element-479" />
          {/* Dots Indicator */}
          <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2" data-id="element-480">
            {court.images.map((_, index) => <button key={index} onClick={() => setCurrentImageIndex(index)} className={`w-2 h-2 rounded-full transition-all ${index === currentImageIndex ? 'bg-white w-6' : 'bg-white/50'}`} data-id="element-481" />)}
          </div>
        </div>

        <div className="px-6 py-6 pb-28 space-y-6" data-id="element-482">
          {/* Court Info */}
          <div data-id="element-483">
            <h1 className="text-3xl font-bold text-[#1f5070] mb-2" data-id="element-484">
              {court.name}
            </h1>
            <div className="flex items-center gap-2 mb-1" data-id="element-485">
              <div className="flex" data-id="element-486">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className={`w-5 h-5 ${star <= Math.floor(court.rating) ? 'fill-[#FFB300] text-[#FFB300]' : 'text-gray-300'}`} data-id="element-487" />)}
              </div>
              <span className="text-lg font-bold text-[#1f5070]" data-id="element-488">
                {court.rating}
              </span>
              <span className="text-sm text-gray-500" data-id="element-489">
                ({court.reviews} reviews)
              </span>
            </div>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-2 gap-3" data-id="element-490">
            <div className="bg-[#f8f9fa] rounded-lg p-4" data-id="element-491">
              <div className="flex items-center gap-2 mb-1" data-id="element-492">
                <CheckCircleIcon className="w-5 h-5 text-[#3dc7e3]" data-id="element-493" />
                <span className="text-sm font-bold text-[#1f5070]" data-id="element-494">
                  Net Quality
                </span>
              </div>
              <p className="text-sm text-[#666666]" data-id="element-495">{court.netQuality}</p>
            </div>

            <div className="bg-[#f8f9fa] rounded-lg p-4" data-id="element-496">
              <div className="flex items-center gap-2 mb-1" data-id="element-497">
                <CheckCircleIcon className="w-5 h-5 text-[#3dc7e3]" data-id="element-498" />
                <span className="text-sm font-bold text-[#1f5070]" data-id="element-499">
                  Lighting
                </span>
              </div>
              <p className="text-sm text-[#666666]" data-id="element-500">{court.lighting}</p>
            </div>

            <div className="bg-[#f8f9fa] rounded-lg p-4" data-id="element-501">
              <div className="flex items-center gap-2 mb-1" data-id="element-502">
                <CheckCircleIcon className="w-5 h-5 text-[#3dc7e3]" data-id="element-503" />
                <span className="text-sm font-bold text-[#1f5070]" data-id="element-504">
                  Surface
                </span>
              </div>
              <p className="text-sm text-[#666666]" data-id="element-505">{court.surface}</p>
            </div>

            <div className="bg-[#f8f9fa] rounded-lg p-4" data-id="element-506">
              <div className="flex items-center gap-2 mb-1" data-id="element-507">
                <CheckCircleIcon className="w-5 h-5 text-[#3dc7e3]" data-id="element-508" />
                <span className="text-sm font-bold text-[#1f5070]" data-id="element-509">
                  Amenities
                </span>
              </div>
              <p className="text-sm text-[#666666]" data-id="element-510">{court.amenities}</p>
            </div>
          </div>

          {/* Location in Facility - Only show for Lamunin */}
          {venue.id === 'lamunin' && <div className="bg-white border-2 border-[#e0e0e0] rounded-xl p-4" data-id="element-511">
              <div className="flex items-center justify-between mb-3" data-id="element-512">
                <h2 className="text-lg font-bold text-[#1f5070]" data-id="element-513">
                  Location in Facility
                </h2>
                <button onClick={() => setIsLayoutModalOpen(true)} className="flex items-center gap-1 text-sm text-[#3dc7e3] font-bold active:scale-95 transition-transform" data-id="element-514">
                  <MapIcon className="w-4 h-4" data-id="element-515" />
                  View Full Layout
                </button>
              </div>

              {/* Court Layout with Highlight */}
              <div className="relative rounded-lg overflow-hidden bg-gray-100" data-id="element-516">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8PdThQQMcMkM9wLNVrEzR9/court_layout.png" alt="Facility Layout" className="w-full h-auto opacity-40" data-id="element-517" />

                {/* SVG Overlay for Highlight - Only for Lamunin courts */}
                {courtPositions[id as keyof typeof courtPositions] && <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 100 70" preserveAspectRatio="xMidYMid meet" data-id="element-518">
                    <rect x={courtPositions[id as keyof typeof courtPositions].x} y={courtPositions[id as keyof typeof courtPositions].y} width={courtPositions[id as keyof typeof courtPositions].width} height={courtPositions[id as keyof typeof courtPositions].height} fill="rgba(61, 199, 227, 0.3)" stroke="#3dc7e3" strokeWidth="1.2" className="animate-pulse" rx="1.5" data-id="element-519" />

                    <text x={courtPositions[id as keyof typeof courtPositions].labelX} y={courtPositions[id as keyof typeof courtPositions].labelY} textAnchor="middle" dominantBaseline="middle" fontSize="5" fontWeight="bold" fill="white" stroke="#1f5070" strokeWidth="0.3" className="drop-shadow-lg" data-id="element-520">
                      {court.name}
                    </text>
                  </svg>}

                {/* Compass Rose */}
                <div className="absolute top-2 right-2 bg-white/90 rounded-full p-2 shadow-md" data-id="element-521">
                  <svg width="40" height="40" viewBox="0 0 40 40" className="text-[#1f5070]" data-id="element-522">
                    <polygon points="20,8 22,16 18,16" fill="currentColor" data-id="element-523" />
                    <text x="20" y="7" textAnchor="middle" fontSize="8" fontWeight="bold" fill="currentColor" data-id="element-524">
                      N
                    </text>
                    <polygon points="20,32 18,24 22,24" fill="currentColor" opacity="0.4" data-id="element-525" />
                    <text x="20" y="37" textAnchor="middle" fontSize="8" fill="currentColor" opacity="0.4" data-id="element-526">
                      S
                    </text>
                    <polygon points="32,20 24,18 24,22" fill="currentColor" opacity="0.4" data-id="element-527" />
                    <text x="36" y="22" textAnchor="middle" fontSize="8" fill="currentColor" opacity="0.4" data-id="element-528">
                      E
                    </text>
                    <polygon points="8,20 16,22 16,18" fill="currentColor" opacity="0.4" data-id="element-529" />
                    <text x="4" y="22" textAnchor="middle" fontSize="8" fill="currentColor" opacity="0.4" data-id="element-530">
                      W
                    </text>
                    <circle cx="20" cy="20" r="2" fill="currentColor" data-id="element-531" />
                  </svg>
                </div>
              </div>

              <p className="text-xs text-[#666666] mt-2 text-center" data-id="element-532">
                Your court is highlighted in cyan • Tap "View Full Layout" for
                details
              </p>
            </div>}

          {/* Pricing */}
          <div className="bg-gradient-to-r from-[#3dc7e3]/10 to-[#c7f61e]/10 rounded-xl p-4" data-id="element-533">
            <div className="mb-2" data-id="element-534">
              <span className="text-2xl font-bold text-[#3dc7e3]" data-id="element-535">
                {court.priceUC} UC
              </span>
              <span className="text-xl text-[#666666]" data-id="element-536">
                {' '}
                or ${court.price}/hour
              </span>
            </div>
            <p className="text-sm text-[#666666]" data-id="element-537">
              Peak hours: {court.peakPriceUC} UC or ${court.peakPrice}/hour
            </p>
          </div>

          {/* Selected Time */}
          <div className="bg-white border-2 border-[#3dc7e3] rounded-xl p-4" data-id="element-538">
            <div className="flex items-center justify-between" data-id="element-539">
              <div className="flex-1 min-w-0" data-id="element-540">
                <p className="text-sm text-[#666666] mb-1" data-id="element-541">Selected Time</p>
                <p className="text-base sm:text-lg font-bold text-[#1f5070] break-words" data-id="element-542">
                  Tomorrow • 3:00 PM - 4:00 PM
                </p>
              </div>
              <button onClick={() => navigate('/calendar')} className="text-sm text-[#3dc7e3] font-bold active:scale-95 transition-transform ml-4 flex-shrink-0" data-id="element-543">
                Edit
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Button - Fixed with proper safe area */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 pb-safe shadow-lg" data-id="element-544">
        <Button variant="primary" fullWidth onClick={handleAddToBooking} data-id="element-545">
          Add to Booking
        </Button>
      </div>

      <FacilityLayoutModal isOpen={isLayoutModalOpen} onClose={() => setIsLayoutModalOpen(false)} data-id="element-546" />
    </div>;
}